<div *ngFor="let commandSchema of commandsSchema" class="card mb-4 pb-2 px-3" style="margin-top: 15px;">
  <div class="card-header pt-1">
    <h4 class="mb-1">{{'model.encoder' | transloco}} {{commandSchema.name}}</h4>
  </div>
  <hr>
  <div class="px-1">
    <app-zmx-commands
      *ngIf="commandSchema.name === 'zmxconnect-0262-v1'"
      [schema]="commandSchema"
      (executeCommand)="executeCommand(commandSchema.name, $event)"
    ></app-zmx-commands>
    <app-industrial-gateway-commands
      *ngIf="commandSchema.name.indexOf('industrial-gateway-v') !== -1"
      [device]="device"
      [schema]="commandSchema"
      (executeCommand)="executeCommand(commandSchema.name, $event)"
    ></app-industrial-gateway-commands>
  </div>
</div>
<div class="flex" *ngIf="!loadingSchemas && (!commandsSchema || commandsSchema.length === 0)" style="margin-top: 15px;">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.commands' | transloco}}</p>
  </div>
</div>
<div class="flex fadein" style="margin-top: 15px;" *ngIf="loadingSchemas">
  <div class="card w-full">
    <p-skeleton height="15rem"></p-skeleton>
  </div>
</div>
